import { render } from "./SavedPaymentContainer.vue?vue&type=template&id=53c23274&scoped=true"
import script from "./SavedPaymentContainer.vue?vue&type=script&lang=js"
export * from "./SavedPaymentContainer.vue?vue&type=script&lang=js"

import "./SavedPaymentContainer.vue?vue&type=style&index=0&id=53c23274&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c23274"]])

export default __exports__